import React, { FC, useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import {
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  WebAuthnAbortService,
} from "@simplewebauthn/browser";
import { useAppDispatch, useAppSelector } from "config/hooks";
import passkeysAPI from "api/passkeys";
import { signInWithPasskey } from "reducers/auth";
import { browserUsedPasskey } from "utils/passkeys";
import logger from "utils/logger";

// "Sign in with a passkey" under the password form (RM-3845). Renders nothing
// until owl says passkeys are on. Where the browser supports it, passkeys are
// also offered in the email field's autofill menu (the field needs
// autoComplete="username webauthn").
const PasskeySignIn: FC = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.auth.isLoading);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    let active = true;
    if (!browserSupportsWebAuthn()) return undefined;

    passkeysAPI
      .getStatus()
      .then(async (status) => {
        if (!active || !status.enabled) return;
        setShowButton(status.show_sign_in_button || browserUsedPasskey());
        if (await browserSupportsWebAuthnAutofill()) {
          if (active) dispatch(signInWithPasskey({ autofill: true }) as any);
        }
      })
      .catch(logger.error);

    return () => {
      active = false;
      // Don't leave an autofill request waiting after leaving the page.
      WebAuthnAbortService.cancelCeremony();
    };
  }, [dispatch]);

  if (!showButton) return null;

  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      <Box className="text-muted small" sx={{ mb: 1 }}>
        or
      </Box>
      <Button
        variant="outlined"
        fullWidth
        disabled={isLoading}
        startIcon={<FontAwesomeIcon icon={faKey} />}
        onClick={() => dispatch(signInWithPasskey() as any)}
      >
        Sign in with a passkey
      </Button>
    </Box>
  );
};

export default PasskeySignIn;
